export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14913.18f2bc9e.jpg";